export default Object.freeze({
  Reports: 210,
  User: 211,
});
